import React, { useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTop = ({ history, children }) => {
    useEffect(() => {
        const unlisten = history.listen(() => {
            window.scrollTo(0, 0);
        });
        return () => {
            unlisten();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <Fragment>{children}</Fragment>;
}
//@ts-ignore
export default withRouter(ScrollToTop);